export default __webpack_public_path__ + "static/media/logo.eac5283b.jpg";